<template>
  <router-view />
</template>

<script>
export default {
  name: 'PreLogin',
};
</script>
